import { render, staticRenderFns } from "./ButtonEditPriority.vue?vue&type=template&id=946eb712&scoped=true"
import script from "./ButtonEditPriority.vue?vue&type=script&lang=js"
export * from "./ButtonEditPriority.vue?vue&type=script&lang=js"
import style0 from "./ButtonEditPriority.vue?vue&type=style&index=0&id=946eb712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946eb712",
  null
  
)

export default component.exports